import React from 'react';
import StoreManager from '../appdata';
import languages from '../appdata/languages';

class LeftMenu extends React.Component {
  state = {
    selectedIndex: 0,
    hoveredIndex: null, // 🆕 theo dõi hover

  };

  componentDidMount() {
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].AppLanguage;
    const path = window.location.pathname;
    const sections = this.props.sections;

    const mapping = {
      [content.submenuAbout]: { subPage: 'AboutContent', path: '/about' },
      [content.submenuGame]: { subPage: 'Game2024Content', path: '/about/game' },
      [content.submenuZalo]: { subPage: 'Zalo2024Content', path: '/about/zalo' },
      [content.submenuZaloPay]: { subPage: 'Zalopay2024Content', path: '/about/zalopay' },
      [content.submenuDB]: { subPage: 'DigitalBusiness2024Content', path: '/about/digital-business' },
      [content.submenuVNGPS]: { subPage: 'VNGPeopleStrategyContent', path: '/about/people-strategy' },
      [content.submenuVNGATCRS]: { subPage: 'VNGsApproachToCSRContent', path: '/about/csr' },
      [content.submenuDigitalTransformation]: { subPage: 'DigitalTransformationContent', path: '/digital' },
      [content.submenu2024Highlight]: { subPage: 'Highlight2024Content', path: '/strategy/highlight' },
      [content.submenuCorporateStructure]: { subPage: 'CorporateStructureContent', path: '/strategy/structure' },
      [content.submenuMacroeconomicOverview]: { subPage: 'MacroeconomicOverviewContent', path: '/strategy/macroeconomy' },
      [content.submenuMDA]: { subPage: 'ManagementReportContent1', path: '/report/mda' },
      [content.submenuAnalysis]: { subPage: 'ManagementReportContent2', path: '/report/analysis' },
      [content.submenuAssessment]: { subPage: 'ManagementReportContent3', path: '/report/assessment' },
    };

    const sectionIndex = sections.findIndex((section) => {
      return mapping[section]?.path === path;
    });

    if (sectionIndex !== -1) {
      this.setState({ selectedIndex: sectionIndex });
    }
  }

  handleSelect = (index) => {
    this.setState({ selectedIndex: index });
    const key = this.props.sections[index];

    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].AppLanguage;

    const setAppState = StoreManager.appState.thisApp.setState.bind(StoreManager.appState.thisApp);
    const mapping = {
      [content.submenuAbout]: { subPage: 'AboutContent', path: '/about' },
      [content.submenuGame]: { subPage: 'Game2024Content', path: '/about/game' },
      [content.submenuZalo]: { subPage: 'Zalo2024Content', path: '/about/zalo' },
      [content.submenuZaloPay]: { subPage: 'Zalopay2024Content', path: '/about/zalopay' },
      [content.submenuDB]: { subPage: 'DigitalBusiness2024Content', path: '/about/digital-business' },
      [content.submenuVNGPS]: { subPage: 'VNGPeopleStrategyContent', path: '/about/people-strategy' },
      [content.submenuVNGATCRS]: { subPage: 'VNGsApproachToCSRContent', path: '/about/csr' },
      [content.submenuDigitalTransformation]: { subPage: 'DigitalTransformationContent', path: '/digital' },
      [content.submenu2024Highlight]: { subPage: 'Highlight2024Content', path: '/strategy/highlight' },
      [content.submenuCorporateStructure]: { subPage: 'CorporateStructureContent', path: '/strategy/structure' },
      [content.submenuMacroeconomicOverview]: { subPage: 'MacroeconomicOverviewContent', path: '/strategy/macroeconomy' },
      [content.submenuMDA]: { subPage: 'ManagementReportContent1', path: '/report/mda' },
      [content.submenuAnalysis]: { subPage: 'ManagementReportContent2', path: '/report/analysis' },
      [content.submenuAssessment]: { subPage: 'ManagementReportContent3', path: '/report/assessment' },
    };

    const target = mapping[key];
    if (target) {
      setAppState({ subPageContent: target.subPage });
      window.history.pushState({}, '', target.path);
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  render() {
    const { selectedIndex } = this.state;
    const { sections } = this.props;

    return (
      <div style={{ paddingTop: 24, fontWeight: 400, fontFamily: 'Inter28-SemiBold' }}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {sections.map((section, index) => {
            const isSelected = index === selectedIndex;
            return (
              <li
              key={index}
              onClick={() => this.handleSelect(index)}
              onMouseEnter={() => this.setState({ hoveredIndex: index })}
              onMouseLeave={() => this.setState({ hoveredIndex: null })}
              style={{
                lineHeight: 1.2,
                marginBottom: 16,
                fontWeight: 500,
                cursor: 'pointer',
                color:
                  isSelected || this.state.hoveredIndex === index
                    ? '#F15A24'
                    : '#1A1A1A',
                borderBottom:
                  isSelected || this.state.hoveredIndex === index
                    ? '1px solid #F15A24'
                    : 'none',
                width: 'fit-content',
                transition: 'all 0.2s ease', // mượt hơn khi hover
              }}
            >
              {section}
            </li>
            
            );
          })}
        </ul>
      </div>
    );
  }
}

export default LeftMenu;
